import { render, staticRenderFns } from "./ElectionResultList.vue?vue&type=template&id=2955d78d&scoped=true"
import script from "./ElectionResultList.vue?vue&type=script&lang=js"
export * from "./ElectionResultList.vue?vue&type=script&lang=js"
import style0 from "./ElectionResultList.vue?vue&type=style&index=0&id=2955d78d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955d78d",
  null
  
)

export default component.exports